import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import {
	LoginContainer,
	GridBackground,
	LoginPaper,
} from 'components/ApplicationStyles'
import SearchOffIcon from '@mui/icons-material/SearchOff'
import HomeIcon from '@mui/icons-material/Home'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

const Error404 = () => {
	const navigate = useNavigate()

	const handleGoHome = () => {
		navigate('/')
	}

	return (
		<LoginContainer maxWidth={false}>
			<GridBackground />
			<LoginPaper elevation={0}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						textAlign: 'center',
						gap: 3,
					}}
				>
					{/* 아이콘 */}
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							width: 100,
							height: 100,
							borderRadius: '50%',
							background: 'linear-gradient(135deg, #ffa726 0%, #ff9800 100%)',
							boxShadow: '0 8px 25px rgba(255, 167, 38, 0.3)',
						}}
					>
						<SearchOffIcon
							sx={{
								fontSize: 50,
								color: '#fff',
							}}
						/>
					</Box>

					{/* 제목 */}
					<Typography
						variant="h3"
						sx={{
							color: '#fff',
							fontWeight: 'bold',
							textShadow: '0 2px 10px rgba(0, 0, 0, 0.3)',
						}}
					>
						404
					</Typography>

					{/* 부제목 */}
					<Typography
						variant="h5"
						sx={{
							color: 'rgba(255, 255, 255, 0.9)',
							fontWeight: '500',
							mb: 1,
						}}
					>
						페이지를 찾을 수 없습니다
					</Typography>

					{/* 설명 */}
					<Typography
						variant="body1"
						sx={{
							color: 'rgba(255, 255, 255, 0.7)',
							lineHeight: 1.6,
							maxWidth: 300,
						}}
					>
						요청하신 페이지가 존재하지 않거나
						<br />
						이동되었을 수 있습니다.
					</Typography>

					{/* 버튼들 */}
					<Box
						sx={{
							display: 'flex',
							gap: 2,
							mt: 2,
						}}
					>
						<Button
							variant="contained"
							onClick={handleGoHome}
							startIcon={<HomeIcon />}
							sx={{
								background: 'linear-gradient(135deg, #4C51D3 0%, #6366f1 100%)',
								color: '#fff',
								py: 1.5,
								px: 3,
								borderRadius: '12px',
								textTransform: 'none',
								fontWeight: '600',
								boxShadow: '0 4px 15px rgba(76, 81, 211, 0.4)',
								'&:hover': {
									background: 'linear-gradient(135deg, #3b40c7 0%, #4f46e5 100%)',
									boxShadow: '0 6px 20px rgba(76, 81, 211, 0.5)',
								},
							}}
						>
							홈으로 가기
						</Button>
					</Box>

					{/* 추가 정보 */}
					<Typography
						variant="caption"
						sx={{
							color: 'rgba(255, 255, 255, 0.5)',
							textAlign: 'center',
							mt: 2,
						}}
					>
						© 2025 MindCline. All rights reserved.
					</Typography>
				</Box>
			</LoginPaper>
		</LoginContainer>
	)
}

export default Error404
